import { createGlobalStyle } from "styled-components"

const normalize = `
  /*! modern-normalize | MIT License | https://github.com/sindresorhus/modern-normalize */html{box-sizing:border-box}*,::after,::before{box-sizing:inherit}:root{-moz-tab-size:4;tab-size:4}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'}hr{height:0}abbr[title]{text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:SFMono-Regular,Consolas,'Liberation Mono',Menlo,Courier,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{padding:0}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}
`

const GlobalStyles = createGlobalStyle`
  ${normalize};

  :root {
    --reach-dialog: 1;
    font-size: 16px;
    letter-spacing: 0.05rem;
    font-weight: 400;
    @media (max-width: ${props => props.theme.screen.sm}) {
      font-size: 18px;
    }
    color: var(--color-text);
    background: var(--color-primary);
  }

  html {
    scroll-behavior: smooth;
  }

  .display {
    font-family: var(--font-display);
  }

  body {
    font-family: var(--font-secondary);
    font-size: var(--font-size-body);
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-primary);
    margin: 0;
    word-break: break-word;
    a {
      color: inherit;
    }
  }

  h1 {
    font-size: var(--font-size-h1);
  }

  h2 {
    font-size: var(--font-size-h2);
  }

  h3 {
    font-size: var(--font-size-h3);
  }

  h4 {
    font-size: var(--font-size-h4);
  }

  h5 {
    font-size: var(--font-size-h5);
  }

  h6 {
    font-size: var(--font-size-h6);
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
  }

  p, ul, ol {
    font-size:  var(--font-size-body);
    line-height: 2rem;
  }

  main li:not(:last-child) {
    margin: 0.5rem 0;
  }

  blockquote {
    quotes: "“" "”" "‘" "’";
    &::before {
      content: open-quote;
      font-family: var(--font-primary);
      font-size: var(--font-size-h1);
    }
    background: var(--color-secondary);
    padding: 1em;
  }

  button {
    border: none;
    background: none;
    outline: none;
    padding: 0;
    cursor: pointer;
    color: var(--color-highlight);
    opacity: 0.8;
    &:hover {
      opacity: 1;
    }
    &[disabled] {
      opacity: 0.4;
    }
  }

  a {
    cursor: pointer;
    text-decoration: none;
    color: var(--color-highlight);
    opacity: 0.8;
    &:hover {
      opacity: 1;
    }
  }

  strong {
    font-weight: 600;
  }

  i, em {
    font-family: var(--font-emph);
  }
`

export default GlobalStyles
